import React, { useState } from 'react';
import { Box, Button, Text, Select, Flex, FlexItem } from '@bigcommerce/big-design';
import { PayPalButton } from 'react-paypal-button-v2';
import { useSelector, useDispatch } from 'react-redux';
import { addOrder } from '../ordersSlice';
import { updateExpire } from '../authSlice';

/**
 * Component xử lý đơn hàng và thanh toán
 */
const Order = () => {
    const dispatch = useDispatch();
    const { store_hash } = useSelector(state => state.auth.data) || {};
    const monthlyFee = Number(process.env.MONTHLY_FEE);
    const [amount, setAmount] = useState(monthlyFee.toFixed(2));

    const amountOptions = [
        { value: monthlyFee.toFixed(2), content: `1 Month [$${monthlyFee.toFixed(0)}]` },
        { value: (monthlyFee * 3).toFixed(2), content: `3 Months [$${(monthlyFee * 3).toFixed(0)}]` },
        { value: (monthlyFee * 6).toFixed(2), content: `6 Months [$${(monthlyFee * 6).toFixed(0)}]` },
        { value: (monthlyFee * 12).toFixed(2), content: `1 Year [$${(monthlyFee * 12).toFixed(0)}]` },
    ]

    const createOrder = (data, actions) => {
        return actions.order.create({
            purchase_units: [{
                description: `Product Review Images - ${amountOptions.filter(item => item.value === amount)[0].content}`,
                amount: {
                    currency_code: 'USD',
                    value: amount,
                },
                // reference_id: storeHash,
                custom_id: store_hash,
            }],
            application_context: {
                shipping_preference: 'NO_SHIPPING',
            },
        });
    };

    const paymentSuccess = async (details, data) => {
        const action = await dispatch(addOrder(data.orderID));
        const { expire } = action.payload || {};
        if (expire) {
            dispatch(updateExpire({ expire }));
        }
    };

    const MonthSelect = () => <Box display="inline-block" style={{width: '150px'}}>
        <Select
            filterable={false}
            onOptionChange={(val) => setAmount(val)}
            options={amountOptions}
            value={amount}
        />
        </Box>;

    return(
        <>
            {store_hash ?
                <Flex alignItems="center">
                    <FlexItem marginRight="small">
                        <MonthSelect />
                    </FlexItem>
                    <FlexItem>
                        <PayPalButton
                            createOrder={createOrder}
                            onSuccess={paymentSuccess}
                            options={{
                                clientId: process.env.PAYPAL_CLIENT_ID,
                            }}
                            style={{
                                color: 'gold',
                                shape: 'rect',
                                size: 'medium',
                                height: 36,
                                label: 'pay',
                                tagline: false,
                                layout: 'horizontal',
                                fundingicons: false,
                                funding: {
                                    allowed: ['credit', 'card']
                                },
                            }}
                        />
                    </FlexItem>
                </Flex>
                : ''}
        </>
    );
}

/**
 * Component hiển thị thông tin subscription và nút thanh toán
 */
const Subscription = () => {
    const auth = useSelector(state => state.auth.data);
    const { trial, expire = null } = auth || {};
    const expiredDate = new Date(expire).toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric'  });

    return (
        <>
            {auth && expire ?
                <Flex alignItems="center">
                    <FlexItem marginRight="small">
                        {trial
                            ? <Text as="div" color="danger40">Trial due <strong>{expiredDate}</strong>. Subscribe</Text>
                            : <Text as="div" color="secondary60">Your subscription due <strong>{expiredDate}</strong>. Renew</Text>}
                    </FlexItem>
                    <FlexItem>
                        <Order />
                    </FlexItem>
                </Flex> : ''}
        </>
    );
}

export { Order, Subscription };
export default Order;
